import { useRef } from "react";

import "./MensajeCard.css";

const VARIABLES = [
  "{NOMBRE}",
  "{PACIENTE}",
  "{EMAIL}",
  "{TELEFONO}",
];

export default function MensajeCard({
  campaign,
  setCampaign,
}) {
  const textareaRef = useRef(null);

  function updateField(field, value) {
    setCampaign((previousCampaign) => ({
      ...previousCampaign,
      [field]: value,
    }));
  }

  function insertVariable(variable) {
    const textarea = textareaRef.current;
    const currentBody = campaign.body || "";

    if (!textarea) {
      updateField("body", `${currentBody}${variable}`);
      return;
    }

    const selectionStart =
      textarea.selectionStart ?? currentBody.length;

    const selectionEnd =
      textarea.selectionEnd ?? currentBody.length;

    const newBody =
      currentBody.slice(0, selectionStart) +
      variable +
      currentBody.slice(selectionEnd);

    updateField("body", newBody);

    const newCursorPosition =
      selectionStart + variable.length;

    window.requestAnimationFrame(() => {
      textarea.focus();
      textarea.setSelectionRange(
        newCursorPosition,
        newCursorPosition,
      );
    });
  }

  const subjectLength = (campaign.subject || "").length;
  const bodyLength = (campaign.body || "").length;

  return (
    <section className="campaign-card message-card">
      <div className="campaign-card-header">
        <div className="campaign-card-title">
          <span className="campaign-card-icon">
            <i
              className="fa-solid fa-envelope-open-text"
              aria-hidden="true"
            />
          </span>

          <div>
            <h2>Correo</h2>

            <p>
              Escribe el asunto y el contenido que recibirán los
              destinatarios.
            </p>
          </div>
        </div>
      </div>

      <div className="message-group">
        <div className="message-label-row">
          <label htmlFor="campaign-subject">
            Asunto
          </label>

          <span className="message-character-count">
            {subjectLength} caracteres
          </span>
        </div>

        <input
          id="campaign-subject"
          type="text"
          placeholder="Ej. Información importante sobre septiembre"
          value={campaign.subject || ""}
          onChange={(event) =>
            updateField("subject", event.target.value)
          }
        />
      </div>

      <div className="message-group variables-group">
        <div className="message-label-row">
          <span className="message-group-title">
            Variables
          </span>
        </div>

        <div className="variables-inline">
          {VARIABLES.map((variable) => (
            <button
              key={variable}
              type="button"
              className="variable-chip"
              onClick={() => insertVariable(variable)}
              title={`Insertar ${variable}`}
            >
              {variable}
            </button>
          ))}
        </div>
      </div>

      <div className="message-group message-body-group">
        <div className="message-label-row">
          <label htmlFor="campaign-body">
            Mensaje
          </label>

          <span className="message-character-count">
            {bodyLength} caracteres
          </span>
        </div>

        <textarea
          ref={textareaRef}
          id="campaign-body"
          placeholder={`Hola {NOMBRE},

Queríamos informaros de...

Muchas gracias.

Equipo TE AYUDO.`}
          value={campaign.body || ""}
          onChange={(event) =>
            updateField("body", event.target.value)
          }
        />
      </div>
    </section>
  );
}